export default __webpack_public_path__ + "static/media/(10).e2662406.jpeg";